// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ExpenseConciliationLinkDespesasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for expense_conciliation_link_despesas /payroll/expense_conciliation_link_despesas
 * Returns the count of linked expenses
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_ExpenseConciliationLinkDespesasResponseDados {
linked_count: number
}

export type Payroll_ExpenseConciliationLinkDespesasResponse = ApiResponse<Payroll_ExpenseConciliationLinkDespesasResponseDados>;

registerResponseContract('Payroll_ExpenseConciliationLinkDespesasResponse', {
  linked_count: { type: 'number',  required: true },
})
